import React from 'react';
import PropTypes from 'prop-types';
import swal from 'sweetalert';
import * as browserCheck from '../../utils/browserCheck.js';

class SweetAlertInput extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.changeText = this.changeText.bind(this);
        this.state = { 
            text: ''
        };        
    }

    componentDidMount() {  
        if (browserCheck.canUseDom()) {
            window.setTimeout(() =>
                window.componentHandler.upgradeDom(), 1000
            );
        }    
    }

    changeText(e) {
        const text = e.target.value;
        this.setState({
            text
        });
        swal.setActionValue(text);
    }

    render() {
        return (
            <form>
                <div className="form form-signup form-tightfields">
                    <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block">
                        <input id="alertInput" name="alertInput" className="mdl-textfield__input" value={this.state.text} onChange={this.changeText} {...this.props} />
                        <label className="mdl-textfield__label" htmlFor="alertInput">{this.props.label || 'Enter value'}</label>
                    </div>          
                </div>  
            </form>                                          
        );
    }
}

SweetAlertInput.propTypes = {
    label: PropTypes.string
};

export default SweetAlertInput;